import jsonp from "../../assets/js/http";
import { Component, Vue } from "vue-property-decorator";
import PacketRain from '../../theme/components/packetRain/packetRain.vue'

@Component({
	components: { PacketRain },
})
export default class broadLive extends Vue {
	isPacketStart: boolean = false // 开始红包雨
	packetStatus: number = 3 // 红包雨活动状态，1 预热，2 开始，3 结束
	packetPreTime: number = 10000 // 红包雨倒计时
	isPacketFail: boolean = false // 抽奖失败
	isPacketSucc: boolean = false // 抽奖成功   app红包雨
	showCenter: any = false
	statement: any = ''
	live_room_redrain_text: any = "//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/common-recommend-cdn/v2/recommend/indexFeaturedGet/live_room_redrain_text/0/live_room_redrain_text" // 红包规则
	prizeInfos: any = {}//抽奖奖品
	// 红包雨错误信息
	popFailData: any = {
		title: "",
		text: " ",
	}
	succCount: any = 0;//击中红包数量
	params: any = {}//当前页面地址栏所带参数


	isClosedH5: any = true
	isShoWanimating: any = false
	startX: any = 0
	startTime: any = 0
	slideVaild: any = false
	cutoutImage: any = ''
	shadeImage: any = ''
	imgX: any = 0
	imgY: any = 0
	postion: any = ''
	moveCount: any = 0
	mouseoverInfo: any = ''
	errTips: any = false
	checkCode: any = ''
	dataKey: any = ''
	useTime: any = 0
	mounted() {
		console.log('=====页面参数', this.$route.params)
		this.params = this.$route.params;
		this.packInit()
		this.getValidate()
	}

	// 红包雨查询
	packInit() {
		if (this.params.packetCode) {
			// 获取活动code
			this.isPacketStart = true;
			this.isPacketFail = false;//红包雨开始时关闭抽奖结果弹框
			this.isPacketSucc = false;//红包雨开始时关闭抽奖结果弹框
		}
	}
	resetValidate() {
		this.errTips = true
		document.getElementsByClassName('validateContent')[0].classList.add("shake")
		this.getValidate()
		setTimeout(() => {
			document.getElementsByClassName('validateContent')[0].classList.remove("shake")
		}, 1000);
		let imgBtn: any = document.querySelector('.imgBtn')
		let rightBtn: any = document.querySelector('.rightBtn')
		imgBtn.style.left = 0
		rightBtn.style.left = 0
	}

	handleMouseUp() {
		(window as any).uleStatUtil.sendView(location.href, { relateType: 'redPackets', relateId1: this.params.roomNumber, relateId2: this.params.packetCode });
		this.moveCount = 0
		this.useTime = (new Date().valueOf()) - this.startTime
		this.mouseoverInfo = this.mouseoverInfo.substr(0, this.mouseoverInfo.length - 1)
		let url = `https://service${process.env.VUE_APP_URI_DOMAIN}/lottry/lottery/lottry`
		let channel: any = {
			'usq': '610001',
			'ule': '300000',
			'uxd': '600000',
			'uleapp': '200000',
		}
		jsonp(url, {
			key: this.dataKey,
			x: parseInt(this.imgX),
			useTime: this.useTime,
			y: parseInt(this.imgY),
			mouseoverInfo: this.mouseoverInfo,
			activityCode: this.params.packetCode,
			channel: channel[this.source] || '200000',
			liveRoomNum: this.$route.params.roomNumber,
			fieldId: "",
			deviceId: ""
		}).then((data: any) => {
			this.isClosedH5 = false
			let prizeInfos: any = data.content.prizeInfos[0];
			if (prizeInfos.prizeTypeDesc_v2 == '40600') {//2022.10.21余陈德确认50503奖品下线了，改为40600
				// if(prizeInfos.prizeType=='50503'){//产品确认将奖品类型40600改为50503
				this.isPacketSucc = true;
				//抽中活动奖励金
				this.prizeInfos = prizeInfos;
			} else {
				//其他奖品,目前只有活动奖金，万一设置错误给用户显示没抽中的提示
				this.packetFail({
					title: "这次没抢到哦换个姿势试试吧",
					text: " ",
				})
			}
			this.isShoWanimating = false
			this.$forceUpdate()

		}).catch(((res: any) => {
			if (res.code == '99785') {
				this.resetValidate()
				return
			}
			this.packetFail({
				title: "这次没抢到哦换个姿势试试吧",
				text: " ",
			})
			this.isClosedH5 = false
			this.isShoWanimating = false
		}))
	}


	handleMouseDown(e: any) {
		const rightBtn: any = document.querySelector('.rightBtn');
		const validateContent: any = document.querySelector('.validateContent');
		this.startTime = new Date().valueOf()
		this.startX = (e.clientX || e.touches[0].clientX) - rightBtn.offsetLeft + validateContent.offsetLeft
	}
	getValidate() {
		const callback = 'h5'
		jsonp(`https://service${process.env.VUE_APP_URI_DOMAIN}/appact/redenvelopes/getCodeImage`, {
			jsoncallback: callback
		}).then((data: any) => {
			this.cutoutImage = 'data:image/png;base64,' + data.cutoutImage
			this.shadeImage = `background:url(data:image/png;base64,${data.shadeImage}) center center`
			this.imgX = data.x
			this.imgY = data.y
			this.postion = `top:${this.imgY}px;left:${this.imgX}px`
			this.dataKey = data.key
		})
	}
	handleMouseMove(e: any) {
		const imgBtn: any = this.$refs.imgBtn
		const rightBtn: any = this.$refs.rightBtn
		this.imgX = (e.clientX || e.touches[0].clientX) - this.startX
		imgBtn.style.left = (e.clientX || e.touches[0].clientX) - this.startX + 'px'
		rightBtn.style.left = (e.clientX || e.touches[0].clientX) - this.startX + 'px'
		if (this.moveCount % 10 == 0) {
			const timeDiff = ((new Date()).valueOf()) - this.startTime;
			this.mouseoverInfo += (parseInt(this.imgX) + "|" + this.imgY + "|" + timeDiff + ",");
			console.log(this.mouseoverInfo)
		}
		const hkwrap: any = document.querySelector('.hkwrap');
		const imgBtns: any = document.querySelector('.imgBtn');
		this.moveCount++
		if (this.imgX <= 0) {
			this.imgX = 0
			imgBtn.style.left = '0px'
			rightBtn.style.left = '0px'
			console.log(this.startX)
		} else if (this.imgX > hkwrap.offsetWidth - imgBtns.offsetWidth) {
			this.imgX = hkwrap.offsetWidth - imgBtns.offsetWidth
			imgBtn.style.left = hkwrap.offsetWidth - imgBtns.offsetWidth + 'px'
			rightBtn.style.left = hkwrap.offsetWidth - imgBtns.offsetWidth + 'px'
		}
		e.preventDefault();
	}
	learnMore() {
		this.showCenter = true
		this.$http
			.jsonp(this.live_room_redrain_text, {
				jsonp: "jsonpCallback",
				jsonpCallback: "live_room_redrain_text",
			}).then((data: any) => {
				if (data.body.returnCode == '0000') {
					this.statement = data.body.indexInfo[0].show_text
					this.isPacketSucc = false
					this.showCenter = true
				}
			})
	}
	// 红包雨
	// 关闭红包雨
	packetClose() {
		this.isPacketStart = false;
		try {
			(window as any).dsBridge.call("hiddenWebAlertView", {});
		} catch (e) { }
	}
	// 抽奖
	prizereceive() {
		(window as any).uleStatUtil.sendView(location.href, { relateType: 'redPackets', relateId1: this.params.roomNumber, relateId2: this.params.packetCode });
		let url = '//service' + this.domain + '/lottry/lottery/lottry';
		let channel: any = {
			'usq': '610001',
			'ule': '300000',
			'uxd': '600000',
			'uleapp': '200000',
		}
		jsonp(url, {
			activityCode: this.params.packetCode,
			channel: channel[this.source] || '200000',
			liveRoomNum: this.$route.params.roomNumber,
			fieldId: "",
			deviceId: ""
		}).then((res: any) => {
			//抽中奖品
			let prizeInfos: any = res.content.prizeInfos[0];
			if (prizeInfos.prizeTypeDesc_v2 == '40600') {//2022.10.21余陈德确认50503奖品下线了，改为40600
				// if(prizeInfos.prizeType=='50503'){//产品确认将奖品类型40600改为50503
				this.isPacketSucc = true;
				//抽中活动奖励金
				this.prizeInfos = prizeInfos;
			} else {
				//其他奖品,目前只有活动奖金，万一设置错误给用户显示没抽中的提示
				this.packetFail({
					title: "这次没抢到哦换个姿势试试吧",
					text: " ",
				})
			}
		})
			.catch((err: any) => {
				this.packetFail({
					title: "这次没抢到哦换个姿势试试吧",
					text: " ",
				})
				// this.$toast(err.message);
			})
	}
	// 抽奖失败
	packetFail(params: any) {
		this.isPacketFail = true
		this.popFailData = params
	}
	// 红包雨结束后的事件
	packetEnd(count: number) {
		this.isPacketStart = false;
		this.succCount = count;//击中红包数量
		// 如果有击中，则请求抽奖
		if (count > 0) {
			// this.prizereceive()
			this.isShoWanimating = true
		}
		// 弹出失败提示
		else {
			this.packetFail({
				title: "这次没抢到哦换个姿势试试吧",
				text: " ",
			})
		}
	}
	closedH5() {
		if (this.isClosedH5) (window as any).dsBridge.call("hiddenWebAlertView", {});
	}
	//关闭抽奖弹框
	closeAlert(type: any) {
		if (type == 1) {
			this.isPacketFail = false;
		} else if (type == 2) {
			this.isPacketSucc = false;
		}

		try {
			(window as any).dsBridge.call("hiddenWebAlertView", {});
		} catch (e) { }
	}
}
